'use strict'

import { merge } from 'lodash-es'

const mutations = {
  reset (state) {
  },
  // 登入弹窗
  setLoginBox (state, options = {}) {
    state.loginBox = merge({
      show: true,
      method: options.method || 'login'
    }, options)
  },
  // 簽到弹窗
  setSignPopup (state, options = {}) {
    state.signPopup = merge({
      show: true,
    }, options)
  },
  // 邀请好友弹窗
  setPalcodePopup (state, options = {}) {
    state.palcodePopup = merge({
      show: true,
    }, options)
  },
  // 提交邀请好友成功弹窗
  setPalcodeSuccessPopup (state, options = {}) {
    state.palcodeSuccessPopup = merge({
      show: true,
    }, options)
  },
  // 修改昵稱弹窗
  setNicknameEditPopup (state, options = {}) {
    state.nicknameEditPopup = merge({
      show: true,
    }, options)
  },
  // 上傳頭像弹窗
  setAvatarUploadPopup (state, options = {}) {
    state.avatarUploadPopup = merge({
      show: true,
    }, options)
  },
  // loading popup
  setLoading (state, status) {
    state.loading = merge({
      show: false
    }, status)
    const loadingCount = state.loadingCount += state.loading.show ? +1 : -1
    state.loadingCount = loadingCount > 0 ? loadingCount : 0
  },
  hideLoading (state) {
    state.loadingCount = 0
    state.loading.show = false
    state.loading.mask = false
  },
  setShowFifaFlag (state, show) {
    state.showFifaFlag = show
  },
  setShowFifaForce (state, force) {
    state.showFifaForce = force
  }
}

export default mutations
